import withRouter from "hoc/withRouter";
import {
  Button,
  Chip,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import trainRunsService from "services/admin/trainRunsService";
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";

const STATUS_LABELS: Record<string, string> = {
  planned: "Запланирован",
  formed: "Сформирован",
  departed: "Отправлен",
  arrived: "Прибыл",
  closed: "Закрыт",
};

const RunList = () => {
  const orgID = localStorage.getItem("orgID") || "";
  const { data: runsResponse, isLoading } = useQuery({
    queryKey: ["train-runs", { orgID }],
    queryFn: async () => {
      const response: any = await trainRunsService.getAll();
      return response.data;
    },
  });

  function buildContent() {
    if (isLoading) {
      return (
        <div className="text-center">
          <CircularProgress />
        </div>
      );
    }
    const rows: any[] = (runsResponse as any)?.data || [];
    if (rows.length === 0) {
      return <div>Рейсы отсутствуют. Они создаются автоматически при оформлении отправок.</div>;
    }
    return (
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>#</TableCell>
            <TableCell>Дата</TableCell>
            <TableCell>Поезд</TableCell>
            <TableCell>Маршрут</TableCell>
            <TableCell>Статус</TableCell>
            <TableCell>Состав</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((r: any, index: number) => (
            <TableRow key={r.id}>
              <TableCell>{index + 1}</TableCell>
              <TableCell>{r.departureDate || "—"}</TableCell>
              <TableCell>{r.train?.number || `#${r.trainID}`}</TableCell>
              <TableCell>
                {(r.originStation?.name || "—") + " → " + (r.destinationStation?.name || "—")}
              </TableCell>
              <TableCell>
                <Chip size="small" label={STATUS_LABELS[r.status] || r.status} />
              </TableCell>
              <TableCell>
                <Link to={`/admin/baggages/runs/${r.id}/composition`}>
                  <Button size="small" variant="outlined">
                    Состав
                  </Button>
                </Link>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    );
  }

  return (
    <div>
      <h2 className="text-2xl m-b-16">Рейсы</h2>
      <div className="m-t-32">{buildContent()}</div>
    </div>
  );
};

export default withRouter(RunList);
